export const UPDATE_WITHDRAW_AMOUNT = 'UPDATE_WITHDRAW_AMOUNT';
